/** Разделы статей/новостей на farkop.ru (навигация между каталогами). */
export const NEWS_SECTIONS = [
  {
    NAME: "Обзоры товаров",
    CODE: "obzory-na-tovary",
  },
  {
    NAME: "Статьи",
    CODE: "articles",
  },
  {
    NAME: "Новости",
    CODE: "news",
  },
  {
    NAME: "Наши работы",
    CODE: "nashe-portfolio",
  },
  {
    NAME: "Акции",
    CODE: "akczii",
  },
];

export const NEWS_PAGE_SIZE = 28;
